/**
 * Headers for correlating SPA traffic with backend / CloudWatch (see backend pino-http `customProps`).
 * Call on every outbound API request (axios + RTK fetchBaseQuery).
 */
export const CLIENT_SOURCE_WEB = 'web';

export function createCorrelationRequestHeaders(): Record<string, string> {
  const rid =
    typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
      ? crypto.randomUUID()
      : `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  return {
    'x-request-id': rid,
    'x-client-source': CLIENT_SOURCE_WEB,
    'x-client-platform': 'WEB',
  };
}
